import "E:\\project\\pc\\gzqx-byyj-pc\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "E:\\project\\pc\\gzqx-byyj-pc\\node_modules\\core-js\\modules\\es6.promise.js";
import "E:\\project\\pc\\gzqx-byyj-pc\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "E:\\project\\pc\\gzqx-byyj-pc\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from 'vue';
import App from "./App.vue";
import router from '@/router';
import store from '@/store';
import '@/directives';
import 'amfe-flexible';
import '@/styles/leaflet-typhoon.scss';
import '@/styles/common.scss';
import 'animate.css';
import 'swiper/css/swiper.min.css';
import '@/views/theme/full-screen.scss';
import 'iview/dist/styles/iview.css'; // 使用 CSS
// import '@/util/console'

import Icon from '@/plugins/icon';
import mixin from '@/minxins';
import VueLoading from '@/components/loading/loading.js';
import MemberPoup from '@/components/member-activation/index/index.js';
import InitStore from "./initStore";
import ECharts from 'vue-echarts'; // 全局挂载事件统计

import eventStatis from "./util/event-statis";
Vue.prototype.$EventStatis = new eventStatis.EventStatis();
var EventStatis = Vue.prototype.$EventStatis; // 引入全屏样式

Vue.component('VChart', ECharts);
Vue.use(Icon);
Vue.use(VueLoading, {
  container: '#app'
});
Vue.use(MemberPoup, store);
Vue.mixin(mixin);
Vue.config.productionTip = false; // 路由后置守卫

router.afterEach(function (to, from) {
  setTimeout(function () {
    // pv事件直接上传path，后端过滤
    var params = {
      eid: "",
      p: {}
    };
    EventStatis.eventPush(params); // 调用所有的点击事件

    EventStatis.allClick();
    checkedInput();
  }, 0);
}); // 输入框过滤sql注入

function checkedInput() {
  var inputs = document.getElementsByTagName('input');

  if (inputs.length) {
    for (var i = 0; i < inputs.length; i++) {
      var element = inputs[i];
      var pat = /select|update|delete|from|exec|count|and|insert*|%|chr|mid|master|truncate|char|declare|or|'|=|;|%/i;

      element.onblur = function (e) {
        if (pat.test(e.target.value)) {
          e.target.value = '';
          alert('文本框输入不支持SQL代码类型！');
        }
      };
    }
  }
} // 初始化配置后再new vue


InitStore(store, router).then(function () {
  new Vue({
    beforeCreate: function beforeCreate() {
      Vue.prototype.$bus = this;
    },
    sockets: {
      connect: function connect() {
        console.log('socket connected');
      }
    },
    router: router,
    store: store,
    render: function render(h) {
      return h(App);
    }
  }).$mount('#app');
}); // store前置